// extracted by mini-css-extract-plugin
export default {"root":"SelectAccounts_root__TznI3","recipients":"SelectAccounts_recipients__DG9h9","button":"SelectAccounts_button__ontYt"};